
export const vitaminsProducts = [
  {
    id: 1,
    name: "Nature Made Vitamin D3 2000 IU",
    price: 12.99,
    originalPrice: 16.99,
    rating: 4.7,
    reviews: 8934,
    image: "https://public.readdy.ai/ai/img_res/931f6dbaac198c9e80cd9bf4cf4f27ea.jpg"
  },
  {
    id: 2,
    name: "Vital Proteins Collagen Peptides",
    price: 43.99,
    originalPrice: 49.99,
    rating: 4.8,
    reviews: 12567,
    image: "https://readdy.ai/api/search-image?query=Vital%20Proteins%20collagen%20peptides%20powder%20container%20with%20clean%20white%20and%20blue%20packaging%20design%2C%20unflavored%20grass-fed%20collagen%20for%20skin%20hair%20nails%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=vitalcoll001&orientation=squarish"
  },
  {
    id: 3,
    name: "Centrum Silver Multivitamin 50+",
    price: 18.99,
    originalPrice: 24.99,
    rating: 4.6,
    reviews: 15234,
    image: "https://readdy.ai/api/search-image?query=Centrum%20Silver%20multivitamin%20bottle%20with%20silver%20and%20blue%20trusted%20brand%20packaging%20design%2C%20complete%20nutrition%20for%20adults%2050%20plus%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=centrumsilv001&orientation=squarish"
  },
  {
    id: 4,
    name: "One A Day Women's Multivitamin",
    price: 14.99,
    originalPrice: 19.99,
    rating: 4.5,
    reviews: 11876,
    image: "https://readdy.ai/api/search-image?query=One%20A%20Day%20womens%20multivitamin%20bottle%20with%20pink%20and%20white%20feminine%20packaging%20design%2C%20complete%20womens%20health%20formula%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=oneadaywoman001&orientation=squarish"
  },
  {
    id: 5,
    name: "Nordic Naturals Ultimate Omega",
    price: 32.99,
    originalPrice: 39.99,
    rating: 4.8,
    reviews: 7654,
    image: "https://readdy.ai/api/search-image?query=Nordic%20Naturals%20Ultimate%20Omega%20fish%20oil%20bottle%20with%20blue%20and%20white%20Nordic%20design%2C%20concentrated%20EPA%20DHA%20omega-3%20supplement%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=nordicult001&orientation=squarish"
  },
  {
    id: 6,
    name: "Garden of Life Prenatal Vitamins",
    price: 39.99,
    originalPrice: 44.99,
    rating: 4.7,
    reviews: 9234,
    image: "https://readdy.ai/api/search-image?query=Garden%20of%20Life%20prenatal%20vitamin%20bottle%20with%20organic%20green%20and%20white%20packaging%20design%2C%20whole%20food%20vitamins%20for%20pregnancy%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=gardenpreg001&orientation=squarish"
  }
];

export const sportsProducts = [
  {
    id: 7,
    name: "Optimum Nutrition Gold Standard Whey",
    price: 58.99,
    originalPrice: 69.99,
    rating: 4.8,
    reviews: 23456,
    image: "https://readdy.ai/api/search-image?query=Optimum%20Nutrition%20Gold%20Standard%20Whey%20Protein%20container%20with%20iconic%20gold%20and%20black%20packaging%20design%2C%20double%20rich%20chocolate%20flavor%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=optgold001&orientation=squarish"
  },
  {
    id: 8,
    name: "Isopure Zero Carb Protein",
    price: 52.99,
    originalPrice: 62.99,
    rating: 4.7,
    reviews: 8765,
    image: "https://readdy.ai/api/search-image?query=Isopure%20Zero%20Carb%20whey%20protein%20isolate%20container%20with%20clean%20white%20and%20blue%20packaging%20design%2C%20zero%20carb%20lactose%20free%20formula%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=isopure001&orientation=squarish"
  },
  {
    id: 9,
    name: "Cellucor C4 Original Pre Workout",
    price: 29.99,
    originalPrice: 34.99,
    rating: 4.6,
    reviews: 13456,
    image: "https://readdy.ai/api/search-image?query=Cellucor%20C4%20Original%20pre-workout%20supplement%20container%20with%20explosive%20blue%20and%20black%20packaging%20design%2C%20energy%20and%20pump%20formula%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=cellc4001&orientation=squarish"
  },
  {
    id: 10,
    name: "Scivation Xtend BCAA",
    price: 34.99,
    originalPrice: 39.99,
    rating: 4.7,
    reviews: 9876,
    image: "https://readdy.ai/api/search-image?query=Scivation%20Xtend%20BCAA%20supplement%20container%20with%20bright%20colorful%20packaging%20design%2C%20branched%20chain%20amino%20acids%20recovery%20formula%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=scivxtend001&orientation=squarish"
  },
  {
    id: 11,
    name: "Optimum Nutrition Micronized Creatine",
    price: 19.99,
    originalPrice: 24.99,
    rating: 4.8,
    reviews: 18765,
    image: "https://readdy.ai/api/search-image?query=Optimum%20Nutrition%20Micronized%20Creatine%20Monohydrate%20container%20with%20classic%20black%20and%20gold%20packaging%20design%2C%20unflavored%20powder%20supplement%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=optcreat001&orientation=squarish"
  },
  {
    id: 12,
    name: "BSN Syntha-6 Protein Powder",
    price: 44.99,
    originalPrice: 52.99,
    rating: 4.6,
    reviews: 7890,
    image: "https://readdy.ai/api/search-image?query=BSN%20Syntha-6%20protein%20powder%20container%20with%20distinctive%20white%20and%20red%20packaging%20design%2C%20ultra-premium%20protein%20matrix%20formula%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=bsnsyntha001&orientation=squarish"
  }
];

export const immunityProducts = [
  {
    id: 13,
    name: "Emergen-C Original Formula",
    price: 12.99,
    originalPrice: 16.99,
    rating: 4.6,
    reviews: 14567,
    image: "https://readdy.ai/api/search-image?query=Emergen-C%20Original%20vitamin%20C%20supplement%20packets%20with%20bright%20orange%20and%20yellow%20packaging%20design%2C%201000mg%20vitamin%20C%20immune%20support%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=emergenc001&orientation=squarish"
  },
  {
    id: 14,
    name: "Nature's Bounty Elderberry Gummies",
    price: 16.99,
    originalPrice: 21.99,
    rating: 4.5,
    reviews: 8932,
    image: "https://readdy.ai/api/search-image?query=Natures%20Bounty%20Elderberry%20gummy%20vitamins%20bottle%20with%20purple%20and%20white%20packaging%20design%2C%20natural%20immune%20support%20with%20berry%20flavor%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=nbelden001&orientation=squarish"
  },
  {
    id: 15,
    name: "Nature Made Zinc 30mg",
    price: 8.99,
    originalPrice: 12.99,
    rating: 4.5,
    reviews: 6789,
    image: "https://readdy.ai/api/search-image?query=Nature%20Made%20Zinc%2030mg%20supplement%20bottle%20with%20blue%20and%20white%20trusted%20brand%20packaging%20design%2C%20immune%20support%20mineral%20supplement%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=nmzinc001&orientation=squarish"
  },
  {
    id: 16,
    name: "Garden of Life Vitamin Code Women",
    price: 44.99,
    originalPrice: 52.99,
    rating: 4.7,
    reviews: 5678,
    image: "https://readdy.ai/api/search-image?query=Garden%20of%20Life%20Vitamin%20Code%20for%20Women%20bottle%20with%20organic%20green%20and%20white%20packaging%20design%2C%20raw%20whole%20food%20multivitamin%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=golvitcode001&orientation=squarish"
  },
  {
    id: 17,
    name: "Culturelle Daily Probiotic",
    price: 24.99,
    originalPrice: 29.99,
    rating: 4.6,
    reviews: 9876,
    image: "https://readdy.ai/api/search-image?query=Culturelle%20Daily%20Probiotic%20capsules%20bottle%20with%20green%20and%20white%20packaging%20design%2C%20digestive%20and%20immune%20health%20support%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=cultprob001&orientation=squarish"
  },
  {
    id: 18,
    name: "Vitafusion Immune Support Gummies",
    price: 13.99,
    originalPrice: 17.99,
    rating: 4.4,
    reviews: 7654,
    image: "https://readdy.ai/api/search-image?query=Vitafusion%20Immune%20Support%20gummy%20vitamins%20bottle%20with%20colorful%20orange%20and%20white%20packaging%20design%2C%20vitamin%20C%20and%20zinc%20gummies%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=vitaimmune001&orientation=squarish"
  }
];

export const brainProducts = [
  {
    id: 19,
    name: "Prevagen Regular Strength",
    price: 39.99,
    originalPrice: 49.99,
    rating: 4.3,
    reviews: 5432,
    image: "https://readdy.ai/api/search-image?query=Prevagen%20Regular%20Strength%20brain%20health%20supplement%20bottle%20with%20blue%20and%20white%20clinical%20packaging%20design%2C%20apoaequorin%20memory%20support%20formula%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=prevagen001&orientation=squarish"
  },
  {
    id: 20,
    name: "Nature's Way Ginkgo Biloba",
    price: 14.99,
    originalPrice: 19.99,
    rating: 4.4,
    reviews: 3876,
    image: "https://readdy.ai/api/search-image?query=Natures%20Way%20Ginkgo%20Biloba%20supplement%20bottle%20with%20green%20and%20white%20natural%20packaging%20design%2C%20cognitive%20function%20and%20circulation%20support%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=nwginkgo001&orientation=squarish"
  },
  {
    id: 21,
    name: "Neuriva Brain Performance",
    price: 34.99,
    originalPrice: 42.99,
    rating: 4.2,
    reviews: 4567,
    image: "https://readdy.ai/api/search-image?query=Neuriva%20Brain%20Performance%20supplement%20bottle%20with%20modern%20purple%20and%20white%20packaging%20design%2C%20coffee%20cherry%20and%20phosphatidylserine%20formula%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=neuriva001&orientation=squarish"
  },
  {
    id: 22,
    name: "Nature's Bounty Stress Comfort",
    price: 19.99,
    originalPrice: 24.99,
    rating: 4.5,
    reviews: 3234,
    image: "https://readdy.ai/api/search-image?query=Natures%20Bounty%20Stress%20Comfort%20supplement%20bottle%20with%20calming%20blue%20and%20white%20packaging%20design%2C%20ashwagandha%20and%20L-theanine%20formula%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=nbstress001&orientation=squarish"
  },
  {
    id: 23,
    name: "Host Defense Lion's Mane",
    price: 32.99,
    originalPrice: 39.99,
    rating: 4.6,
    reviews: 2845,
    image: "https://readdy.ai/api/search-image?query=Host%20Defense%20Lions%20Mane%20mushroom%20supplement%20bottle%20with%20natural%20brown%20and%20white%20packaging%20design%2C%20cognitive%20and%20nerve%20support%20formula%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=hostlion001&orientation=squarish"
  },
  {
    id: 24,
    name: "NOW Supplements Ashwagandha",
    price: 16.99,
    originalPrice: 21.99,
    rating: 4.5,
    reviews: 6543,
    image: "https://readdy.ai/api/search-image?query=NOW%20Supplements%20Ashwagandha%20extract%20capsules%20bottle%20with%20orange%20and%20white%20packaging%20design%2C%20adaptogenic%20stress%20support%20herb%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=nowash001&orientation=squarish"
  }
];

export const weightProducts = [
  {
    id: 25,
    name: "Hydroxycut Hardcore Next Gen",
    price: 24.99,
    originalPrice: 32.99,
    rating: 4.2,
    reviews: 8765,
    image: "https://readdy.ai/api/search-image?query=Hydroxycut%20Hardcore%20Next%20Gen%20weight%20loss%20supplement%20bottle%20with%20intense%20black%20and%20red%20packaging%20design%2C%20thermogenic%20fat%20burner%20formula%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=hydrocut001&orientation=squarish"
  },
  {
    id: 26,
    name: "Leanbean Female Fat Burner",
    price: 59.99,
    originalPrice: 69.99,
    rating: 4.4,
    reviews: 4567,
    image: "https://readdy.ai/api/search-image?query=Leanbean%20female%20fat%20burner%20supplement%20bottle%20with%20elegant%20pink%20and%20white%20packaging%20design%2C%20natural%20weight%20management%20for%20women%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=leanbean001&orientation=squarish"
  },
  {
    id: 27,
    name: "Natrol Green Coffee Bean Extract",
    price: 12.99,
    originalPrice: 17.99,
    rating: 4.1,
    reviews: 3456,
    image: "https://readdy.ai/api/search-image?query=Natrol%20Green%20Coffee%20Bean%20Extract%20supplement%20bottle%20with%20natural%20green%20and%20white%20packaging%20design%2C%20weight%20management%20support%20formula%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=natrolcoffee001&orientation=squarish"
  },
  {
    id: 28,
    name: "Sports Research CLA 1250",
    price: 24.99,
    originalPrice: 29.99,
    rating: 4.3,
    reviews: 5432,
    image: "https://readdy.ai/api/search-image?query=Sports%20Research%20CLA%201250%20supplement%20bottle%20with%20blue%20and%20white%20packaging%20design%2C%20conjugated%20linoleic%20acid%20weight%20management%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=srcla001&orientation=squarish"
  },
  {
    id: 29,
    name: "PhenQ All-in-One Weight Loss",
    price: 69.99,
    originalPrice: 79.99,
    rating: 4.3,
    reviews: 6789,
    image: "https://readdy.ai/api/search-image?query=PhenQ%20all-in-one%20weight%20loss%20supplement%20bottle%20with%20modern%20white%20and%20orange%20packaging%20design%2C%20multi-action%20fat%20burning%20formula%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=phenq001&orientation=squarish"
  },
  {
    id: 30,
    name: "Goli Apple Cider Vinegar Gummies",
    price: 19.99,
    originalPrice: 24.99,
    rating: 4.4,
    reviews: 12345,
    image: "https://readdy.ai/api/search-image?query=Goli%20Apple%20Cider%20Vinegar%20gummies%20bottle%20with%20bright%20red%20and%20white%20packaging%20design%2C%20natural%20weight%20management%20gummies%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=goliacv001&orientation=squarish"
  }
];

export const heartProducts = [
  {
    id: 31,
    name: "Qunol CoQ10 100mg",
    price: 24.99,
    originalPrice: 32.99,
    rating: 4.6,
    reviews: 8934,
    image: "https://readdy.ai/api/search-image?query=Qunol%20CoQ10%20100mg%20supplement%20bottle%20with%20yellow%20and%20white%20packaging%20design%2C%20ultra%20absorbable%20heart%20health%20support%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=qunolcoq10001&orientation=squarish"
  },
  {
    id: 32,
    name: "Nature Made Fish Oil 1200mg",
    price: 18.99,
    originalPrice: 24.99,
    rating: 4.5,
    reviews: 11234,
    image: "https://readdy.ai/api/search-image?query=Nature%20Made%20Fish%20Oil%201200mg%20supplement%20bottle%20with%20blue%20and%20white%20trusted%20brand%20packaging%20design%2C%20omega-3%20heart%20health%20support%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=nmfishoil001&orientation=squarish"
  },
  {
    id: 33,
    name: "Carlson The Very Finest Fish Oil",
    price: 31.99,
    originalPrice: 39.99,
    rating: 4.8,
    reviews: 6789,
    image: "https://readdy.ai/api/search-image?query=Carlson%20The%20Very%20Finest%20Fish%20Oil%20bottle%20with%20premium%20blue%20and%20white%20packaging%20design%2C%20lemon%20flavor%20omega-3%20supplement%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=carlsonfish001&orientation=squarish"
  },
  {
    id: 34,
    name: "Natrol Omega-3 Fish Oil",
    price: 16.99,
    originalPrice: 21.99,
    rating: 4.4,
    reviews: 4567,
    image: "https://readdy.ai/api/search-image?query=Natrol%20Omega-3%20Fish%20Oil%20supplement%20bottle%20with%20blue%20and%20white%20packaging%20design%2C%20heart%20and%20brain%20health%20support%20formula%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=natrolomega001&orientation=squarish"
  },
  {
    id: 35,
    name: "Life Extension Magnesium L-Threonate",
    price: 39.99,
    originalPrice: 49.99,
    rating: 4.5,
    reviews: 3456,
    image: "https://readdy.ai/api/search-image?query=Life%20Extension%20Magnesium%20L-Threonate%20supplement%20bottle%20with%20scientific%20white%20and%20blue%20packaging%20design%2C%20cardiovascular%20and%20brain%20support%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=lemag001&orientation=squarish"
  },
  {
    id: 36,
    name: "NOW Supplements Hawthorn Extract",
    price: 12.99,
    originalPrice: 16.99,
    rating: 4.3,
    reviews: 2345,
    image: "https://readdy.ai/api/search-image?query=NOW%20Supplements%20Hawthorn%20Extract%20bottle%20with%20orange%20and%20white%20packaging%20design%2C%20traditional%20heart%20health%20herbal%20support%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=nowhawthorn001&orientation=squarish"
  }
];

export const digestiveProducts = [
  {
    id: 37,
    name: "Align Probiotic Daily Supplement",
    price: 34.99,
    originalPrice: 42.99,
    rating: 4.6,
    reviews: 9876,
    image: "https://readdy.ai/api/search-image?query=Align%20Probiotic%20Daily%20Supplement%20bottle%20with%20clean%20blue%20and%20white%20clinical%20packaging%20design%2C%20digestive%20health%20probiotic%20formula%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=alignprob001&orientation=squarish"
  },
  {
    id: 38,
    name: "Garden of Life Dr. Formulated Probiotics",
    price: 47.99,
    originalPrice: 54.99,
    rating: 4.7,
    reviews: 6543,
    image: "https://readdy.ai/api/search-image?query=Garden%20of%20Life%20Dr%20Formulated%20Probiotics%20for%20Women%20bottle%20with%20organic%20green%20and%20white%20packaging%20design%2C%20vaginal%20and%20digestive%20health%20support%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=goldrprob001&orientation=squarish"
  },
  {
    id: 39,
    name: "Renewlife Ultimate Flora Probiotic",
    price: 42.99,
    originalPrice: 52.99,
    rating: 4.5,
    reviews: 5432,
    image: "https://readdy.ai/api/search-image?query=Renewlife%20Ultimate%20Flora%20Probiotic%20bottle%20with%20green%20and%20white%20natural%20packaging%20design%2C%2050%20billion%20live%20cultures%20digestive%20support%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=renewprob001&orientation=squarish"
  },
  {
    id: 40,
    name: "Iberogast Digestive Relief",
    price: 28.99,
    originalPrice: 34.99,
    rating: 4.4,
    reviews: 3456,
    image: "https://readdy.ai/api/search-image?query=Iberogast%20Digestive%20Relief%20liquid%20supplement%20bottle%20with%20traditional%20green%20and%20yellow%20packaging%20design%2C%20herbal%20digestive%20comfort%20formula%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=iberogast001&orientation=squarish"
  },
  {
    id: 41,
    name: "NOW Supplements L-Glutamine Powder",
    price: 19.99,
    originalPrice: 24.99,
    rating: 4.5,
    reviews: 4321,
    image: "https://readdy.ai/api/search-image?query=NOW%20Supplements%20L-Glutamine%20Powder%20container%20with%20orange%20and%20white%20packaging%20design%2C%20gut%20health%20and%20recovery%20amino%20acid%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=nowglut001&orientation=squarish"
  },
  {
    id: 42,
    name: "Metamucil Daily Fiber Supplement",
    price: 22.99,
    originalPrice: 27.99,
    rating: 4.6,
    reviews: 8765,
    image: "https://readdy.ai/api/search-image?query=Metamucil%20Daily%20Fiber%20Supplement%20container%20with%20orange%20and%20white%20trusted%20brand%20packaging%20design%2C%20psyllium%20husk%20digestive%20health%2C%20professional%20product%20photography%20on%20white%20background&width=400&height=400&seq=metamucil001&orientation=squarish"
  }
];
